<app-simple-grid
  [listOperator]="listReservationValuesOperator"
  [createOperator]="createReservationValueOperator"
  [updateOperator]="updateReservationValueOperator"
  [detailsOperator]="detailsReservationValueOperator"
  [deleteOperator]="deleteReservationValueOperator"
  [cellValueChangeOperator]="cellValueChangeOperator()"
  [baseActions]="baseActions()"
  [rowActionSelector]="rowActionSelector"
  [enablePagination]="false"
  [columnDefs]="columnDefs()"
  [rowClassRules]="rowClassRules" />
